import classes from "./Navbar.module.scss";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { APIContext } from "../../connector";
import profileImg from "../../static/images/user.svg";
import homeImg from "../../static/images/home.svg";
import signoutImg from "../../static/images/signout.svg";
import logo from "../../static/images/Logo.png";
import supportImg from "../../static/images/support.svg";
import switchImg from "../../static/images/switch.svg";
import historyImg from "../../static/images/history.svg";

const Navbar = () => {
  const SUPPORT_URL = "https://forms.gle/gBmNZuXcatt5sSMF6";
  const location = useLocation();
  const { logout, userData, switchProfile } = useContext(APIContext);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const locationsWithoutNavbar = ["/", "/login", "/register", "/driverRegister", "/waiting"];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {!locationsWithoutNavbar.includes(location.pathname) && (
        <nav className={`${classes.navbar} ${isMenuOpen ? classes.open : ""}`}>
          <div className={classes.toggleSection}>
            <div className={classes.toggle} onClick={toggleMenu}>
              <span className={classes.toggleIcon}>☰</span>
            </div>
          </div>
          <div
            className={classes.overlay}
            onClick={() => {
              setIsMenuOpen(false);
            }}
          ></div>
          <div className={classes.navLinksSection}>
            <div className={classes.navLinks}>
              <img src={logo} alt="Logo" className={classes.logo} />

              <hr className={classes.seprator} />

              {/* Home */}
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className={`${classes.navLink} ${location.pathname === "/" ? classes.active : ""}`}
              >
                <div className={classes.navLinkIconSection}>
                  <img src={homeImg} alt="Home" />
                </div>
                <div className={classes.navLinkTextSection}>
                  <p className={classes.navLinkText}>Home</p>
                </div>
              </Link>

              {/* Profile */}
              <Link
                to={"/profile/" + userData.user_id}
                onClick={() => setIsMenuOpen(false)}
                className={`${classes.navLink} ${location.pathname === `/profile` ? classes.active : ""}`}
              >
                <div className={classes.navLinkIconSection}>
                  <img src={profileImg} alt="Profile" />
                </div>
                <div className={classes.navLinkTextSection}>
                  <p className={classes.navLinkText}>Profile</p>
                </div>
              </Link>

              {/* Report */}
              <div className={classes.navLink} onClick={() => {
                setIsMenuOpen(false);
                window.open(SUPPORT_URL, "_blank");
              }}>
                <div className={classes.navLinkIconSection}>
                  <img src={supportImg} alt="support" width={20} />
                </div>
                <div className={classes.navLinkTextSection}>
                  <p className={classes.navLinkText}>Report</p>
                </div>
              </div>

              {/* Switch profile / Register as driver */}
              {/* if user is a driver, allow switching profiles */}
              {userData.is_driver && (
                <div className={`${classes.navLink}`} onClick={async () => {
                  setIsMenuOpen(false);
                  await switchProfile();
                  //refresh the page to reflect changes
                  window.location.reload();
                }}
                >
                  <div className={classes.navLinkIconSection}>
                    <img src={profileImg} alt="Switch Profile" />
                  </div>
                  <div className={classes.navLinkTextSection}>
                    <p className={classes.navLinkText}>Switch Profile</p>
                  </div>
                </div>
              )}
              {userData.is_driver && (
                <Link
                  to="/trip-history"
                  onClick={() => setIsMenuOpen(false)}
                  className={`${classes.navLink} ${location.pathname === "/trip-history" ? classes.active : ""}`}
                >
                  <div className={classes.navLinkIconSection}>
                    <img src={historyImg} alt="Trip History" />
                  </div>
                  <div className={classes.navLinkTextSection}>
                    <p className={classes.navLinkText}>Trip History</p>
                  </div>
                </Link>
              )}
              {/* otherwise, allow registering as driver */}
              {!userData.is_driver && (
                <Link
                  to="/driverRegister"
                  onClick={() => setIsMenuOpen(false)}
                  className={`${classes.navLink}`}
                >
                  <div className={classes.navLinkIconSection}>
                    <img src={switchImg} alt="Register as Driver" />
                  </div>
                  <div className={classes.navLinkTextSection}>
                    <p className={classes.navLinkText}>Switch Status</p>
                  </div>
                </Link>
              )}

              {!userData.is_driver && (
                <Link
                  to="/trip-history"
                  onClick={() => setIsMenuOpen(false)}
                  className={`${classes.navLink} ${location.pathname === "/trip-history" ? classes.active : ""}`}
                >
                  <div className={classes.navLinkIconSection}>
                    <img src={historyImg} alt="Trip History" />
                  </div>
                  <div className={classes.navLinkTextSection}>
                    <p className={classes.navLinkText}>Trip History</p>
                  </div>
                </Link>
              )}

              <hr className={classes.seprator} />

              {/* Sign out */}
              <div className={classes.navLink} onClick={() => {
                setIsMenuOpen(false);
                logout();
              }}>
                <div className={classes.navLinkIconSection}>
                  <img src={signoutImg} alt="Sign out" />
                </div>
                <div className={classes.navLinkTextSection}>
                  <p style={{ color: 'red' }} className={classes.navLinkText}>Sign out</p>
                </div>
              </div>




            </div>

          </div>
        </nav>
      )}
    </>
  );
};

export default Navbar;
